import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { createAggregatedClient } from "@smithy/smithy-client";
import { AbortMultipartUploadCommand } from "./commands/AbortMultipartUploadCommand";
import { CompleteMultipartUploadCommand } from "./commands/CompleteMultipartUploadCommand";
import { CopyObjectCommand } from "./commands/CopyObjectCommand";
import { CreateBucketCommand } from "./commands/CreateBucketCommand";
import { CreateBucketMetadataTableConfigurationCommand } from "./commands/CreateBucketMetadataTableConfigurationCommand";
import { CreateMultipartUploadCommand } from "./commands/CreateMultipartUploadCommand";
import { CreateSessionCommand } from "./commands/CreateSessionCommand";
import { DeleteBucketAnalyticsConfigurationCommand } from "./commands/DeleteBucketAnalyticsConfigurationCommand";
import { DeleteBucketCommand } from "./commands/DeleteBucketCommand";
import { DeleteBucketCorsCommand } from "./commands/DeleteBucketCorsCommand";
import { DeleteBucketEncryptionCommand } from "./commands/DeleteBucketEncryptionCommand";
import { DeleteBucketIntelligentTieringConfigurationCommand } from "./commands/DeleteBucketIntelligentTieringConfigurationCommand";
import { DeleteBucketInventoryConfigurationCommand } from "./commands/DeleteBucketInventoryConfigurationCommand";
import { DeleteBucketLifecycleCommand } from "./commands/DeleteBucketLifecycleCommand";
import { DeleteBucketMetadataTableConfigurationCommand } from "./commands/DeleteBucketMetadataTableConfigurationCommand";
import { DeleteBucketMetricsConfigurationCommand } from "./commands/DeleteBucketMetricsConfigurationCommand";
import { DeleteBucketOwnershipControlsCommand } from "./commands/DeleteBucketOwnershipControlsCommand";
import { DeleteBucketPolicyCommand } from "./commands/DeleteBucketPolicyCommand";
import { DeleteBucketReplicationCommand } from "./commands/DeleteBucketReplicationCommand";
import { DeleteBucketTaggingCommand } from "./commands/DeleteBucketTaggingCommand";
import { DeleteBucketWebsiteCommand } from "./commands/DeleteBucketWebsiteCommand";
import { DeleteObjectCommand } from "./commands/DeleteObjectCommand";
import { DeleteObjectsCommand } from "./commands/DeleteObjectsCommand";
import { DeleteObjectTaggingCommand } from "./commands/DeleteObjectTaggingCommand";
import { DeletePublicAccessBlockCommand } from "./commands/DeletePublicAccessBlockCommand";
import { GetBucketAccelerateConfigurationCommand } from "./commands/GetBucketAccelerateConfigurationCommand";
import { GetBucketAclCommand } from "./commands/GetBucketAclCommand";
import { GetBucketAnalyticsConfigurationCommand } from "./commands/GetBucketAnalyticsConfigurationCommand";
import { GetBucketCorsCommand } from "./commands/GetBucketCorsCommand";
import { GetBucketEncryptionCommand } from "./commands/GetBucketEncryptionCommand";
import { GetBucketIntelligentTieringConfigurationCommand } from "./commands/GetBucketIntelligentTieringConfigurationCommand";
import { GetBucketInventoryConfigurationCommand } from "./commands/GetBucketInventoryConfigurationCommand";
import { GetBucketLifecycleConfigurationCommand } from "./commands/GetBucketLifecycleConfigurationCommand";
import { GetBucketLocationCommand } from "./commands/GetBucketLocationCommand";
import { GetBucketLoggingCommand } from "./commands/GetBucketLoggingCommand";
import { GetBucketMetadataTableConfigurationCommand } from "./commands/GetBucketMetadataTableConfigurationCommand";
import { GetBucketMetricsConfigurationCommand } from "./commands/GetBucketMetricsConfigurationCommand";
import { GetBucketNotificationConfigurationCommand } from "./commands/GetBucketNotificationConfigurationCommand";
import { GetBucketOwnershipControlsCommand } from "./commands/GetBucketOwnershipControlsCommand";
import { GetBucketPolicyCommand } from "./commands/GetBucketPolicyCommand";
import { GetBucketPolicyStatusCommand } from "./commands/GetBucketPolicyStatusCommand";
import { GetBucketReplicationCommand } from "./commands/GetBucketReplicationCommand";
import { GetBucketRequestPaymentCommand } from "./commands/GetBucketRequestPaymentCommand";
import { GetBucketTaggingCommand } from "./commands/GetBucketTaggingCommand";
import { GetBucketVersioningCommand } from "./commands/GetBucketVersioningCommand";
import { GetBucketWebsiteCommand } from "./commands/GetBucketWebsiteCommand";
import { GetObjectAclCommand } from "./commands/GetObjectAclCommand";
import { GetObjectAttributesCommand } from "./commands/GetObjectAttributesCommand";
import { GetObjectCommand } from "./commands/GetObjectCommand";
import { GetObjectLegalHoldCommand } from "./commands/GetObjectLegalHoldCommand";
import { GetObjectLockConfigurationCommand } from "./commands/GetObjectLockConfigurationCommand";
import { GetObjectRetentionCommand } from "./commands/GetObjectRetentionCommand";
import { GetObjectTaggingCommand } from "./commands/GetObjectTaggingCommand";
import { GetObjectTorrentCommand } from "./commands/GetObjectTorrentCommand";
import { GetPublicAccessBlockCommand } from "./commands/GetPublicAccessBlockCommand";
import { HeadBucketCommand } from "./commands/HeadBucketCommand";
import { HeadObjectCommand } from "./commands/HeadObjectCommand";
import { ListBucketAnalyticsConfigurationsCommand } from "./commands/ListBucketAnalyticsConfigurationsCommand";
import { ListBucketIntelligentTieringConfigurationsCommand } from "./commands/ListBucketIntelligentTieringConfigurationsCommand";
import { ListBucketInventoryConfigurationsCommand } from "./commands/ListBucketInventoryConfigurationsCommand";
import { ListBucketMetricsConfigurationsCommand } from "./commands/ListBucketMetricsConfigurationsCommand";
import { ListBucketsCommand } from "./commands/ListBucketsCommand";
import { ListDirectoryBucketsCommand } from "./commands/ListDirectoryBucketsCommand";
import { ListMultipartUploadsCommand } from "./commands/ListMultipartUploadsCommand";
import { ListObjectsCommand } from "./commands/ListObjectsCommand";
import { ListObjectsV2Command } from "./commands/ListObjectsV2Command";
import { ListObjectVersionsCommand } from "./commands/ListObjectVersionsCommand";
import { ListPartsCommand } from "./commands/ListPartsCommand";
import { PutBucketAccelerateConfigurationCommand } from "./commands/PutBucketAccelerateConfigurationCommand";
import { PutBucketAclCommand } from "./commands/PutBucketAclCommand";
import { PutBucketAnalyticsConfigurationCommand } from "./commands/PutBucketAnalyticsConfigurationCommand";
import { PutBucketCorsCommand } from "./commands/PutBucketCorsCommand";
import { PutBucketEncryptionCommand } from "./commands/PutBucketEncryptionCommand";
import { PutBucketIntelligentTieringConfigurationCommand } from "./commands/PutBucketIntelligentTieringConfigurationCommand";
import { PutBucketInventoryConfigurationCommand } from "./commands/PutBucketInventoryConfigurationCommand";
import { PutBucketLifecycleConfigurationCommand } from "./commands/PutBucketLifecycleConfigurationCommand";
import { PutBucketLoggingCommand } from "./commands/PutBucketLoggingCommand";
import { PutBucketMetricsConfigurationCommand } from "./commands/PutBucketMetricsConfigurationCommand";
import { PutBucketNotificationConfigurationCommand } from "./commands/PutBucketNotificationConfigurationCommand";
import { PutBucketOwnershipControlsCommand } from "./commands/PutBucketOwnershipControlsCommand";
import { PutBucketPolicyCommand } from "./commands/PutBucketPolicyCommand";
import { PutBucketReplicationCommand } from "./commands/PutBucketReplicationCommand";
import { PutBucketRequestPaymentCommand } from "./commands/PutBucketRequestPaymentCommand";
import { PutBucketTaggingCommand } from "./commands/PutBucketTaggingCommand";
import { PutBucketVersioningCommand } from "./commands/PutBucketVersioningCommand";
import { PutBucketWebsiteCommand } from "./commands/PutBucketWebsiteCommand";
import { PutObjectAclCommand } from "./commands/PutObjectAclCommand";
import { PutObjectCommand } from "./commands/PutObjectCommand";
import { PutObjectLegalHoldCommand } from "./commands/PutObjectLegalHoldCommand";
import { PutObjectLockConfigurationCommand } from "./commands/PutObjectLockConfigurationCommand";
import { PutObjectRetentionCommand } from "./commands/PutObjectRetentionCommand";
import { PutObjectTaggingCommand } from "./commands/PutObjectTaggingCommand";
import { PutPublicAccessBlockCommand } from "./commands/PutPublicAccessBlockCommand";
import { RestoreObjectCommand } from "./commands/RestoreObjectCommand";
import { SelectObjectContentCommand } from "./commands/SelectObjectContentCommand";
import { UploadPartCommand } from "./commands/UploadPartCommand";
import { UploadPartCopyCommand } from "./commands/UploadPartCopyCommand";
import { WriteGetObjectResponseCommand } from "./commands/WriteGetObjectResponseCommand";
import { S3Client } from "./S3Client";
var commands = {
  AbortMultipartUploadCommand: AbortMultipartUploadCommand,
  CompleteMultipartUploadCommand: CompleteMultipartUploadCommand,
  CopyObjectCommand: CopyObjectCommand,
  CreateBucketCommand: CreateBucketCommand,
  CreateBucketMetadataTableConfigurationCommand: CreateBucketMetadataTableConfigurationCommand,
  CreateMultipartUploadCommand: CreateMultipartUploadCommand,
  CreateSessionCommand: CreateSessionCommand,
  DeleteBucketCommand: DeleteBucketCommand,
  DeleteBucketAnalyticsConfigurationCommand: DeleteBucketAnalyticsConfigurationCommand,
  DeleteBucketCorsCommand: DeleteBucketCorsCommand,
  DeleteBucketEncryptionCommand: DeleteBucketEncryptionCommand,
  DeleteBucketIntelligentTieringConfigurationCommand: DeleteBucketIntelligentTieringConfigurationCommand,
  DeleteBucketInventoryConfigurationCommand: DeleteBucketInventoryConfigurationCommand,
  DeleteBucketLifecycleCommand: DeleteBucketLifecycleCommand,
  DeleteBucketMetadataTableConfigurationCommand: DeleteBucketMetadataTableConfigurationCommand,
  DeleteBucketMetricsConfigurationCommand: DeleteBucketMetricsConfigurationCommand,
  DeleteBucketOwnershipControlsCommand: DeleteBucketOwnershipControlsCommand,
  DeleteBucketPolicyCommand: DeleteBucketPolicyCommand,
  DeleteBucketReplicationCommand: DeleteBucketReplicationCommand,
  DeleteBucketTaggingCommand: DeleteBucketTaggingCommand,
  DeleteBucketWebsiteCommand: DeleteBucketWebsiteCommand,
  DeleteObjectCommand: DeleteObjectCommand,
  DeleteObjectsCommand: DeleteObjectsCommand,
  DeleteObjectTaggingCommand: DeleteObjectTaggingCommand,
  DeletePublicAccessBlockCommand: DeletePublicAccessBlockCommand,
  GetBucketAccelerateConfigurationCommand: GetBucketAccelerateConfigurationCommand,
  GetBucketAclCommand: GetBucketAclCommand,
  GetBucketAnalyticsConfigurationCommand: GetBucketAnalyticsConfigurationCommand,
  GetBucketCorsCommand: GetBucketCorsCommand,
  GetBucketEncryptionCommand: GetBucketEncryptionCommand,
  GetBucketIntelligentTieringConfigurationCommand: GetBucketIntelligentTieringConfigurationCommand,
  GetBucketInventoryConfigurationCommand: GetBucketInventoryConfigurationCommand,
  GetBucketLifecycleConfigurationCommand: GetBucketLifecycleConfigurationCommand,
  GetBucketLocationCommand: GetBucketLocationCommand,
  GetBucketLoggingCommand: GetBucketLoggingCommand,
  GetBucketMetadataTableConfigurationCommand: GetBucketMetadataTableConfigurationCommand,
  GetBucketMetricsConfigurationCommand: GetBucketMetricsConfigurationCommand,
  GetBucketNotificationConfigurationCommand: GetBucketNotificationConfigurationCommand,
  GetBucketOwnershipControlsCommand: GetBucketOwnershipControlsCommand,
  GetBucketPolicyCommand: GetBucketPolicyCommand,
  GetBucketPolicyStatusCommand: GetBucketPolicyStatusCommand,
  GetBucketReplicationCommand: GetBucketReplicationCommand,
  GetBucketRequestPaymentCommand: GetBucketRequestPaymentCommand,
  GetBucketTaggingCommand: GetBucketTaggingCommand,
  GetBucketVersioningCommand: GetBucketVersioningCommand,
  GetBucketWebsiteCommand: GetBucketWebsiteCommand,
  GetObjectCommand: GetObjectCommand,
  GetObjectAclCommand: GetObjectAclCommand,
  GetObjectAttributesCommand: GetObjectAttributesCommand,
  GetObjectLegalHoldCommand: GetObjectLegalHoldCommand,
  GetObjectLockConfigurationCommand: GetObjectLockConfigurationCommand,
  GetObjectRetentionCommand: GetObjectRetentionCommand,
  GetObjectTaggingCommand: GetObjectTaggingCommand,
  GetObjectTorrentCommand: GetObjectTorrentCommand,
  GetPublicAccessBlockCommand: GetPublicAccessBlockCommand,
  HeadBucketCommand: HeadBucketCommand,
  HeadObjectCommand: HeadObjectCommand,
  ListBucketAnalyticsConfigurationsCommand: ListBucketAnalyticsConfigurationsCommand,
  ListBucketIntelligentTieringConfigurationsCommand: ListBucketIntelligentTieringConfigurationsCommand,
  ListBucketInventoryConfigurationsCommand: ListBucketInventoryConfigurationsCommand,
  ListBucketMetricsConfigurationsCommand: ListBucketMetricsConfigurationsCommand,
  ListBucketsCommand: ListBucketsCommand,
  ListDirectoryBucketsCommand: ListDirectoryBucketsCommand,
  ListMultipartUploadsCommand: ListMultipartUploadsCommand,
  ListObjectsCommand: ListObjectsCommand,
  ListObjectsV2Command: ListObjectsV2Command,
  ListObjectVersionsCommand: ListObjectVersionsCommand,
  ListPartsCommand: ListPartsCommand,
  PutBucketAccelerateConfigurationCommand: PutBucketAccelerateConfigurationCommand,
  PutBucketAclCommand: PutBucketAclCommand,
  PutBucketAnalyticsConfigurationCommand: PutBucketAnalyticsConfigurationCommand,
  PutBucketCorsCommand: PutBucketCorsCommand,
  PutBucketEncryptionCommand: PutBucketEncryptionCommand,
  PutBucketIntelligentTieringConfigurationCommand: PutBucketIntelligentTieringConfigurationCommand,
  PutBucketInventoryConfigurationCommand: PutBucketInventoryConfigurationCommand,
  PutBucketLifecycleConfigurationCommand: PutBucketLifecycleConfigurationCommand,
  PutBucketLoggingCommand: PutBucketLoggingCommand,
  PutBucketMetricsConfigurationCommand: PutBucketMetricsConfigurationCommand,
  PutBucketNotificationConfigurationCommand: PutBucketNotificationConfigurationCommand,
  PutBucketOwnershipControlsCommand: PutBucketOwnershipControlsCommand,
  PutBucketPolicyCommand: PutBucketPolicyCommand,
  PutBucketReplicationCommand: PutBucketReplicationCommand,
  PutBucketRequestPaymentCommand: PutBucketRequestPaymentCommand,
  PutBucketTaggingCommand: PutBucketTaggingCommand,
  PutBucketVersioningCommand: PutBucketVersioningCommand,
  PutBucketWebsiteCommand: PutBucketWebsiteCommand,
  PutObjectCommand: PutObjectCommand,
  PutObjectAclCommand: PutObjectAclCommand,
  PutObjectLegalHoldCommand: PutObjectLegalHoldCommand,
  PutObjectLockConfigurationCommand: PutObjectLockConfigurationCommand,
  PutObjectRetentionCommand: PutObjectRetentionCommand,
  PutObjectTaggingCommand: PutObjectTaggingCommand,
  PutPublicAccessBlockCommand: PutPublicAccessBlockCommand,
  RestoreObjectCommand: RestoreObjectCommand,
  SelectObjectContentCommand: SelectObjectContentCommand,
  UploadPartCommand: UploadPartCommand,
  UploadPartCopyCommand: UploadPartCopyCommand,
  WriteGetObjectResponseCommand: WriteGetObjectResponseCommand
};
export var S3 = /*#__PURE__*/function (_S3Client) {
  _inherits(S3, _S3Client);
  var _super = _createSuper(S3);
  function S3() {
    _classCallCheck(this, S3);
    return _super.apply(this, arguments);
  }
  return _createClass(S3);
}(S3Client);
createAggregatedClient(commands, S3);